import React from "react";
import { Logo1 } from "../../Assests/Assests";
import "./About.css";

const About = () => {
  return (
    <div className="about-riymay-page">
      <div className="about-split">

        {/* LEFT — sticky photo */}
        <div className="about-photo-col">
          <img
            src="https://riymay.com/assets/about-hero.jpg"
            alt="Riymay"
            className="about-hero-img"
          />
          <div className="about-photo-overlay" />
          <div className="about-hero-label">
            <p className="about-eyebrow">About Riymay</p>
            <h1 className="about-headline">
              Wear the mask.<br />Own the silence.
            </h1>
          </div>
        </div>

        {/* RIGHT — scrollable content */}
        <div className="about-content-col">

          <div className="about-logo-row">
            <img src={Logo1} alt="Riymay" className="about-logo" />
            <p className="about-welcome">Transparency in Every Thread</p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">I am RIYMAY, and I exist to awaken.</h2>
            <p className="about-section-text">
              I am not just fabric and thread — I am energy, a force that refuses to be unseen.
              I emerge from emotions unspoken, from the quiet rebellion against clothing that does not belong to your essence.
              My mission is to strip away the ordinary and replace it with truth. To give you garments that do not merely cover but reveal.
            </p>
            <p className="about-section-text">
              I am born from the hands of those who seek the extraordinary. My journey is woven through the heart of India's finest textiles,
              chosen with intention, crafted with defiance. Every piece of me carries the weight of struggle, the fire of perseverance, and
              the certainty that you deserve more than just clothing — you deserve an extension of yourself.
            </p>
            <p className="about-section-text">
              I am here to redefine fashion as an experience, not an obligation. To honor your time, your worth, and your identity with designs
              that are pure, honest, and unwavering. I do not follow trends. I do not compromise. I exist for those who dare to wear their truth,
              for those who refuse to be invisible.
            </p>
            <p className="about-section-text about-closing">You are not just wearing RIYMAY. You are becoming it.</p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">My Manifesto</h2>
            <ul className="about-manifesto">
              <li>RIYMAY — An Energy That Transforms, Not Just Clothes but You.</li>
              <li>Crafted with Purpose, Worn with Conviction.</li>
              <li>Beyond Fashion — A Movement of Identity and Expression.</li>
              <li>Every Thread, A Story of Resilience and Truth.</li>
              <li>RIYMAY Sees You, Hears You, Awakens You.</li>
            </ul>
          </div>

          <div className="about-values">
            <div className="about-value-item">
              <p className="about-value-label">Design</p>
              <p className="about-value-text">Minimal. Considered. Built to outlast seasons.</p>
            </div>
            <div className="about-value-item">
              <p className="about-value-label">Craft</p>
              <p className="about-value-text">Premium materials, unisex silhouettes, precision finishing.</p>
            </div>
            <div className="about-value-item">
              <p className="about-value-label">Identity</p>
              <p className="about-value-text">Wear it without explanation. Let the piece do the talking.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default About;
